import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './Timeline.css';
import { ROUTING, TIMELINE } from '../../../constants';

const STEP_PADDING = 80;

const Timeline = ({ categoryId }) => {
  const stops = TIMELINE.map((year, index) => {
    let yearClass = 'year';
    if (categoryId.length > 0) {
      const id = Number(categoryId);
      if (index === id || index === id + 1) {
        yearClass = `${yearClass} hilite`;
      }
    }
    return (
      <Link
        key={year}
        className="stop"
        style={{ left: index * STEP_PADDING }}
        to={`${ROUTING.CATEGORY}/${Math.min(index, 7)}`}
      >
        <div className="dot" />
        <div className={yearClass}>{year}</div>
        {index <= 7 &&
        <div className="line-click" style={{ width: STEP_PADDING }} />
        }
      </Link>
    );
  });

  // fill
  const fillStyle = {};
  if (categoryId.length > 0) {
    fillStyle.width = STEP_PADDING;
    fillStyle.left = Number(categoryId) * STEP_PADDING;
  }

  return (
    <div id="timeline" style={{ width: (TIMELINE.length - 1) * STEP_PADDING }}>
      <div id="line-wrap">
        <div
          id="line-fill"
          style={fillStyle}
        />
      </div>
      { stops }
    </div>
  );
};

const mapStateToProps = state => ({
  categoryId: state.dataCategory.category,
});

Timeline.propTypes = {
  categoryId: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(Timeline);



// WEBPACK FOOTER //
// ./src/components/App/Timeline/Timeline.js